import { Theme, createStyles, makeStyles } from "@material-ui/core"
import { COLORS } from "../../core/consts/redesign/commonRedesign"

export const useStyles = makeStyles((theme: Theme) => createStyles({
    container: {
        padding: '40px 0',
        margin: '0 auto',
        boxSizing: 'border-box',
        maxWidth: '800px',
        width: '800px',
    },
    pageWrap: {
        width: '100%',
        // display: 'flex',
        // justifyContent: 'center',
        // padding: theme.spacing(3),
    },
    paper: {
        borderRadius: '10px',
        flex: 'auto',
        overflowY: 'auto',
        position: 'relative',
        scrollbarWidth: 'thin',
        '&::-webkit-scrollbar': {
            width: '0.5em',
            height: '0.2em',
        },
        '&::-webkit-scrollbar-track': {
            boxShadow: 'inset 0 0 6px rgba(208 217 222 / 88%)',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#D0D9DE',
            outline: '0.2px solid #D0D9DE',
        },
    },
    searchContainer: {
        position: 'sticky',
        top: 0,
        zIndex: 5,
        height: '85px'
    },
    search: {
        backgroundColor: '#ffffff',
        width: '100%!important',
        margin: '0!important',
        '& div::before': {
            display: 'none',
        },
        '& div::after': {
            display: 'none',
        },
        '& input': {
            padding: '25px 25px 15px 15px',
        },
        '& label': {
            padding: '25px 15px',
        },
        boxSizing: 'border-box'
    },
    notificationsBox: {
        height: '80%',
        borderRadius: '10px',
    },


    titleContainer: {
        display: "flex",
        flexDirection: "row",
        width: "100%",
        gap: '12px',
        alignItems: "flex-start",
        justifyContent: "center",
        [theme.breakpoints.down(1024)]: {
            // alignItems: "center",
        },
    },
    imgIcon: {
        width: '40px',
        height: '40px',
        borderRadius: '4px',
    },
    rowBox: {
        display: "flex",
        width: "100%",
        gap: '8px',
        [theme.breakpoints.down(1024)]: {
            flexDirection: "column",
            gap: '1px',
        },
    },
    columnBox: {
        display: "flex",
        flexDirection: "column",
        gap: '4px',
        width: "100%",
    },
    statusBlock: {
        // backgroundColor: COLORS.white,
        display: 'flex',
        width: "100%",
        flexDirection: 'column',
        gap: '24px',
        alignItems: 'flex-start',
        justifyContent: 'center',
        borderRadius: '8px',
        marginBottom: '8px'
    },

    Lead__container: {
        backgroundColor: COLORS.white,
        display: "flex",
        flexDirection: "column",
        width: "100%",
        padding: '24px',
        gap: '24px',
        alignItems: 'flex-start',
        justifyContent: 'center',
        borderRadius: '8px',
    },
    Lead__titleRow: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        cursor: 'pointer'
    },
    Lead__content: {
        width: '100%',
        padding: "0"
    },
}))